import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const setupURI = config.setupApiUrl;
const triggerCompModule = {
  state: {
    dataSet01Source: [],
    triggerComponentList: [],
    triggerSelectBoxList: [],
    triggerId: '',
  },
  mutations: {
    'SET_STORE_TRIGGER_COMPONENT_LIST'(state, triggerComponentList) {
      state.triggerComponentList = triggerComponentList;
      state.dataSet01Source = triggerComponentList;

      state.triggerSelectBoxList = triggerComponentList.map(item => {
        return {
          ...item,
          text: item.tr_name,
          value: item.tr_id,
        };
      });

    },
    'SET_STORE_TRIGGER_ID' (state, id) {
      state.triggerId = id;
    },
  },
  actions: {
    getTriggerComponentList: async ({ commit }, params) => {
      await axios.post(`${setupURI}/trigger/list`, params).then((response) => {
        commit('SET_STORE_TRIGGER_COMPONENT_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    insertTriggerComponent: async ({ commit }, params) => {
      await axios.post(`${setupURI}/trigger/insert`, params).then((response) => {
        commit('SET_STORE_TRIGGER_ID', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    updateTriggerComponent: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/trigger/update`, params);
        commit('SET_STORE_TRIGGER_ID', response.data);
      } catch (err) {
        throw err;
      }
    },
    deleteTriggerComponent: async ({ commit }, params) => {
      await axios.post(`${setupURI}/trigger/delete`, params).then((response) => {
        commit('SET_STORE_TRIGGER_ID', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    getTriggerSelectBoxList: async ({commit}, params) => {
      await axios.post(`${setupURI}/trigger/list`, params).then((response) => {
        commit('SET_STORE_TRIGGER_COMPONENT_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
  },
  getters: {
    triggerComponentList: state => state.triggerComponentList,
    triggerSelectBoxList: state => state.triggerSelectBoxList,
    triggerId: state => state.triggerId,
  }
};
export default triggerCompModule;